import Column from "@amzn/meridian/esm/components/column";
import Row from "@amzn/meridian/esm/components/row";
import Text from "@amzn/meridian/esm/components/text";
import star from "../../../images/star.svg";

// "<name> turned on ..." status for a session someone else started.
const StartedByStatus = ({ startedBy }) => (
  <Row spacing="300" alignmentVertical="top" spacingInset="none none 400 none">
    <img src={star} alt="" />
    <Column spacing="none">
      <Text type="h50">{startedBy.name}</Text>
      <Text type="b200">{startedBy.description}</Text>
    </Column>
  </Row>
);

export default StartedByStatus;
